"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFlightNotificationCount = exports.fetchOfferPaymentSheetParams = exports.fetchFlightPaymentSheetParams = exports.getFlightOfferTotalPrice = exports.getFlightTotalPrice = exports.startFlightOfferPayment = exports.startFlightPayment = exports.changeDedicatedStatus = exports.declineFlightOffer = exports.offerFlight = exports.getFlightOffer = exports.ratePilot = exports.ratePassengers = exports.cancelFlightAsPassenger = exports.cancelFlightAsPilot = exports.getMyFlightDetails = exports.getFlightDetails = exports.publishFlight = exports.getPilotOffers = exports.getPassengerFlights = exports.getPilotFlights = exports.getSearchedFlights = exports.getNearbyFlights = void 0;
const request_1 = __importStar(require("./request"));
const handleError_1 = require("./handleError");
const dictionaries_1 = require("../services/dictionaries");
const lodash_1 = require("lodash");
const getNearbyFlights = async (asAPilot, timezone) => {
    try {
        const response = await (0, request_1.default)(request_1.GET, `flight/nearby?flight_request=${asAPilot}${timezone ? `&user_timezone=${timezone}` : ''}`);
        return response.data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.getNearbyFlights = getNearbyFlights;
const getSearchedFlights = async (searchData, flight_request) => {
    try {
        let route = `flight/?flight_request=${flight_request}`;
        (0, lodash_1.forEach)(searchData, (value, key) => {
            if (value) {
                route += `&${key}=${value}`;
            }
        });
        const response = await (0, request_1.default)(request_1.GET, route);
        return response.data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.getSearchedFlights = getSearchedFlights;
const getPilotFlights = async () => {
    try {
        const response = await (0, request_1.default)(request_1.GET, 'flight/me/pilot');
        return response.data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.getPilotFlights = getPilotFlights;
const getPassengerFlights = async () => {
    try {
        const response = await (0, request_1.default)(request_1.GET, 'flight/me/passenger');
        return response.data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.getPassengerFlights = getPassengerFlights;
const getPilotOffers = async () => {
    try {
        const response = await (0, request_1.default)(request_1.GET, 'flight/me/offer');
        return response.data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.getPilotOffers = getPilotOffers;
const publishFlight = async (publishFlightData) => {
    try {
        const { status, data } = await (0, request_1.default)(request_1.POST, 'flight/', publishFlightData);
        return { status, data };
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.publishFlight = publishFlight;
const getFlightDetails = async (flightId) => {
    try {
        const response = await (0, request_1.default)(request_1.GET, `flight/${flightId}`);
        return response.data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.getFlightDetails = getFlightDetails;
const getMyFlightDetails = async (flightId) => {
    try {
        const response = await (0, request_1.default)(request_1.GET, `flight/me/${flightId}`);
        return response.data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.getMyFlightDetails = getMyFlightDetails;
const cancelFlightAsPilot = async (flightId, cancelMessage) => {
    try {
        return await (0, request_1.default)(request_1.PUT, `flight/${flightId}`, {
            status: dictionaries_1.FlightStatus["CANCELED"],
            cancel_message: cancelMessage
        });
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.cancelFlightAsPilot = cancelFlightAsPilot;
const cancelFlightAsPassenger = async (flightId) => {
    try {
        return await (0, request_1.default)(request_1.PUT, `flight/${flightId}/remove_user`);
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.cancelFlightAsPassenger = cancelFlightAsPassenger;
const ratePassengers = async (flightId, userRatings) => {
    try {
        const response = await (0, request_1.default)(request_1.POST, `flight/${flightId}/rate_passengers`, {
            user_ratings: userRatings
        });
        return response.status;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.ratePassengers = ratePassengers;
const ratePilot = async (flightId, userRating) => {
    try {
        const response = await (0, request_1.default)(request_1.POST, `flight/${flightId}/rate_pilot`, {
            ...userRating
        });
        return response.status;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.ratePilot = ratePilot;
const getFlightOffer = async (offerId) => {
    try {
        const response = await (0, request_1.default)(request_1.GET, `flight/offer/${offerId}`);
        return response.data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.getFlightOffer = getFlightOffer;
const offerFlight = async (flightId, publishFlightOfferData) => {
    try {
        const { status, data } = await (0, request_1.default)(request_1.POST, `flight/${flightId}/offer_flight`, publishFlightOfferData);
        return { status, data };
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.offerFlight = offerFlight;
const declineFlightOffer = async (offerId) => {
    try {
        const response = await (0, request_1.default)(request_1.PUT, `flight/offer/${offerId}/decline`);
        return response.data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.declineFlightOffer = declineFlightOffer;
const changeDedicatedStatus = async (flightId, dedicated) => {
    try {
        return await (0, request_1.default)(request_1.PUT, `flight/${flightId}`, { dedicated });
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.changeDedicatedStatus = changeDedicatedStatus;
const startFlightPayment = async (flightId, passengers) => {
    try {
        return await (0, request_1.default)(request_1.POST, `flight/${flightId}/payment`, { passengers });
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.startFlightPayment = startFlightPayment;
const startFlightOfferPayment = async (offerId, passengers) => {
    try {
        return await (0, request_1.default)(request_1.POST, `flight/offer/${offerId}/payment`, { passengers });
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.startFlightOfferPayment = startFlightOfferPayment;
const getFlightTotalPrice = async (flightId, passengers) => {
    try {
        return await (0, request_1.default)(request_1.GET, `flight/${flightId}/payment/price?passengers=${passengers}`);
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.getFlightTotalPrice = getFlightTotalPrice;
const getFlightOfferTotalPrice = async (offerId, passengers) => {
    try {
        return await (0, request_1.default)(request_1.GET, `flight/offer/${offerId}/payment/price?passengers=${passengers}`);
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.getFlightOfferTotalPrice = getFlightOfferTotalPrice;
const fetchFlightPaymentSheetParams = async (flightId, passengers) => {
    const response = await (0, request_1.default)(request_1.POST, `flight/${flightId}/payment_mobile`, { passengers });
    return response.data;
};
exports.fetchFlightPaymentSheetParams = fetchFlightPaymentSheetParams;
const fetchOfferPaymentSheetParams = async (offerId, passengers) => {
    const response = await (0, request_1.default)(request_1.POST, `flight/offer/${offerId}/payment_mobile`, { passengers });
    return response.data;
};
exports.fetchOfferPaymentSheetParams = fetchOfferPaymentSheetParams;
const getFlightNotificationCount = async () => {
    try {
        const { data } = await (0, request_1.default)(request_1.GET, 'flight/me/notification_count');
        return data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.getFlightNotificationCount = getFlightNotificationCount;
